<template>
  <div class="method">
    <h3 class="title">- 学习方法解释 -</h3>
    <div class="main-body">
      <h4 class="sub-title">“倒逼式”学习方法</h4>
      <p class="content">其实本质就是把学习顺序重新编排一下这就好比一把牌，很好的牌，如果打的顺序不对，也会失败。</p>
      <h4 class="sub-title">什么是试题倒逼学习？</h4>
      <p class="content">
        准备好周测作业，开卷做题，解决每一个选项，为何是错的，在讲义或者教材中划出来后细细的看，不要求记住，不理解的就pass<br/><br/>
        在翻书解决每道习题时，你会发现本来晦涩的教材，一下子找到了重点，做完作业，基本上熟悉了本章的体系了<br/><br/>
        然后参加周测直播课，老师对试题做剖析和举一反三，串联试题背后考点，解惑的同时梳理一下本章重点，课程完结基本掌握本章80%内容。</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LearningMethod',
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
.method {
  padding: 15px;

  .title {
    margin-bottom: 30px;
    text-align: center;
    font-size: 14px;
    color: #999;
  }

  .main-body {
    .sub-title {
      margin-bottom: 10px;
      font-size: 16px;
      color: #333;

      &::before {
        content: "";
        border-left: 5px solid #57a7fc;
        margin-right: 5px;
      }
    }

    .content {
      padding: 10px 15px;
      font-size: 12px;
      line-height: 1.5;
      color: #666;
      background-color: #fff;
      border-radius: 4px;

      ~ .sub-title{
        margin-top: 20px;
      }
    }
  }
}
</style>
